import { render } from "./WifiIcon.vue?vue&type=template&id=08661d2e"
import script from "./WifiIcon.vue?vue&type=script&lang=js"
export * from "./WifiIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__